import './entity-history.scss';

import { map } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Observable } from 'rxjs';
import { Component, Watch } from 'vue-property-decorator';

export interface HistoryRecord {
    author: string | Error | null;
    date?: Date;
    description: string;
    id: string;
    title: string;
}

@Component({
    props: [
        'emptyMessage',
        'entityDataStore',
        'historyStates',
        'sortFields',
        'title',
        'targetRouteName',
        'serializer',
    ],
    template: require('./entity-history.html'),
})
export class EntityHistory<T extends { id: string }> extends ReactiveVue {
    public emptyMessage: string;
    public entityDataStore: EntityDataStore<any>;
    public historyStates: string[];
    public serializer: (entity: T) => Observable<HistoryRecord>;
    public sortFields: string[];
    public targetRouteName: string;
    public title: string;

    public records: HistoryRecord[] = [];

    get fields() {
        return [
            {
                key: 'title',
                label: this.$t('entityHistory.field.title'),
            },
            {
                key: 'author',
                label: this.$t('entityHistory.field.author'),
            },
            {
                formatter: value => this.$i18n.d(value),
                key: 'date',
                label: this.$t('entityHistory.field.date'),
                sortingDirection: 'desc',
            },
        ];
    }

    public created() {
        this.subscribe();
    }

    public subscribe() {
        this.subscribeTo(
            this.entityDataStore
                .fetchAll({
                    query: {
                        ...(this.historyStates.length > 0 && {
                            states: this.historyStates.join(','),
                        }),
                        sortAsc: 'false',
                        ...(this.sortFields.length > 0 && {
                            sortFields: this.sortFields.join(','),
                        }),
                    },
                    userScope: true,
                })
                .pipe(map(this.serializer)),
            records => {
                this.records = records;
            },
            'history',
        );
    }

    public unsubscribe() {
        this.unsubscribeFrom('history');
    }

    @Watch('entityDataStore')
    public onDataStoreChange() {
        this.unsubscribe();
        this.subscribe();
    }

    public onRowClik(record: HistoryRecord) {
        const index = this.records.findIndex(i => i.id === record.id);
        const next = this.records.filter((_, k) => k > index).map(v => v.id);
        const query: Record<string, string> = { next: next as any };

        const params: Record<string, string> = { id: record.id };
        return this.$router.push({
            name: this.targetRouteName,
            params,
            query,
        });
    }
}
